import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as bootstrap from "bootstrap";
import { FaRegAddressCard, FaFilePdf, FaFileArchive, FaFileWord } from "react-icons/fa";
import { FiDownload, FiTrash2, FiEye } from "react-icons/fi";
import { BsPersonBadge, BsFileEarmarkText, BsPlusCircle } from "react-icons/bs";

export default function FileTransfermethod() {
  // State management
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [rolemanagement, setRoleManagement] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalData, setModalData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedType, setSelectedType] = useState("");
  const [documents, setDocuments] = useState([]);

  const itemsPerPage = 5;

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setRoleManagement(payload.role);
      } catch (err) {
        console.error("Invalid token", err);
      }
    }
  }, []);
console.log(rolemanagement);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const res = await axios.get(
        "http://localhost:5890/GETMENSTIONAPI/Bussiness_all_details",
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUsers(Array.isArray(res.data?.customers) ? res.data.customers : []);
    } catch (err) {
      console.error("Fetch error", err);
      toast.error("❌ Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  const fetchDocuments = async (userId) => {
    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.get(
        `http://localhost:5890/getcustomerdocuments/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDocuments(res.data.documents || []);
    } catch (err) {
      console.error("Error fetching documents", err);
      toast.error("Failed to load documents");
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

const filteredUsers = users.filter(user =>
  user?.lastName?.toLowerCase().includes(search.trim().toLowerCase()) ||
  user?.email?.toLowerCase().includes(search.trim().toLowerCase()) ||
  user?.phone?.includes(search.trim())
);


  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const currentUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const openModal = (user) => {
    setModalData(user);
    setSelectedFile(null);
    setSelectedImage(null);
    setSelectedType("");
    const modal = new bootstrap.Modal(document.getElementById("userModal"));
    modal.show();
  };

  const openDocumentsModal = async (user) => {
    setModalData(user);
    await fetchDocuments(user._id);
    const modal = new bootstrap.Modal(document.getElementById("documentsModal"));
    modal.show();
  };

  const handleDocumentUpload = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  

  const handleSave = async () => {
    if (!selectedFile || !selectedType || !modalData?._id) {
      toast.error("Please select a document type and file.");
      return;
    }

    const formData = new FormData();
    formData.append("customerId", modalData._id);
    formData.append("documentType", selectedType);
    formData.append("documentFile", selectedFile);
    if (selectedImage) {
      formData.append("imageFile", selectedImage);
    }

    try {
      const token = sessionStorage.getItem("token");
      const res = await axios.post(
        "http://localhost:5890/uploadcustomerdocument",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      toast.success("📤 Document uploaded successfully!");
      fetchDocuments(modalData._id);
      
      // Close the modal
      const modal = bootstrap.Modal.getInstance(document.getElementById("userModal"));
      modal.hide();
    } catch (err) {
      toast.error("❌ Upload failed");
      console.error(err);
    }
  };

  const deleteDocument = async (docId) => {
    try {
      const token = sessionStorage.getItem("token");
      await axios.delete(
        `http://localhost:5890/deletecustomerdocument/${docId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Document deleted successfully");
      fetchDocuments(modalData._id);
    } catch (err) {
      toast.error("Failed to delete document");
      console.error(err);
    }
  };

  const downloadDocument = async (filePath) => {
    try {
      const token = sessionStorage.getItem("token");
      const fullPath = `http://localhost:5890/${filePath}`;

      const response = await axios.get(fullPath, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        validateStatus: (status) => status < 500,
      });

      if (response.status === 204 || response.data.size === 0) {
        toast.warning("⚠️ No content available to download.");
        return;
      }

      let filename = filePath.split("/").pop();
      const disposition = response.headers["content-disposition"];
      if (disposition && disposition.includes("filename=")) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) {
          filename = decodeURIComponent(match[1]);
        }
      }

      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("✅ Download started!");
    } catch (err) {
      console.error("Download error:", err);
      toast.error("❌ Failed to download document.");
    }
  };

  const getFileIcon = (fileName) => {
    if (fileName?.endsWith(".pdf")) return <FaFilePdf className="text-danger me-2" />;
    if (fileName?.endsWith(".zip")) return <FaFileArchive className="text-primary me-2" />;
    if (fileName?.endsWith(".docx")) return <FaFileWord className="text-info me-2" />;
    return <BsFileEarmarkText className="text-secondary me-2" />;
  };

  return (
    <div className="container-fluid px-4 py-3">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* Main Card */}
      <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
        {/* Header Section */}
        <div className="card-header bg-gradient-success text-white py-3 rounded-top-4">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <h2 className="fw-bold m-0">
              <i className="bi bi-people-fill me-2"></i>
            Document Management
            </h2>
            
            <div className="mt-3 mt-md-0">
              <div className="input-group search-box" style={{ maxWidth: "350px" }}>
                <span className="input-group-text bg-white border-end-0">
                  <i className="bi bi-search text-muted"></i>
                </span>
                <input
                  type="text"
                  className="form-control border-start-0 ps-2 py-2"
                  placeholder="Search by name, email or phone..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Users Table */}
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th className="py-3 px-4">Customer</th>
                  <th className="py-3 px-4">Contact</th>
                  <th className="py-3 px-4">Details</th>
                  <th className="py-3 px-4">Status</th>
                  <th className="py-3 px-4 text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <div className="spinner-border text-success" role="status"></div>
                    </td>
                  </tr>
                ) : currentUsers.length > 0 ? (
                  currentUsers.map((user) => (
                    <tr key={user._id} className="hover-shadow">
                      <td className="px-4 py-3">
                        <div className="d-flex align-items-center gap-3">
                          <div className="position-relative">
                            <img
                              src={user?.photo
                                ? `http://localhost:5890/uploads/${user.photo}`
                                : `https://ui-avatars.com/api/?background=random&name=${user.fullName || user.lastName || 'U'}`}
                              alt="User"
                              className="rounded-circle border border-2 border-white shadow-sm"
                              width="50"
                              height="50"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = `https://ui-avatars.com/api/?background=random&name=${user.fullName || user.lastName || 'U'}`;
                              }}
                            />
                            <span className={`position-absolute bottom-0 end-0 p-1 rounded-circle ${user.status === "Active" ? "bg-success" : "bg-secondary"}`}
                              style={{ border: '2px solid white' }}>
                            </span>
                          </div>
                          <div>
                            <h6 className="mb-0 fw-semibold">{user.fullName} {user.lastName}</h6>
                            <small className="text-muted">{user.role || "Customer"}</small>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <i className="bi bi-envelope text-orange"></i>
                          <span>{user.email || "N/A"}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <i className="bi bi-telephone text-orange"></i>
                          <span>{user.phone || "N/A"}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <i className="bi bi-geo-alt text-orange"></i>
                          <span>{user.address?.district || 'Not Mention'}, {user.address?.state || 'Not Mention'}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <i className="bi bi-calendar text-orange"></i>
                          <span>{new Date(user.createdAt).toLocaleDateString()}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`badge rounded-pill px-3 py-2 ${user.status === "Active" ? "bg-success bg-opacity-10 text-success" : "bg-secondary bg-opacity-10 text-secondary"}`}>
                          {user.status}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-end">
                        <div className="d-flex gap-2 justify-content-end">
                          <button
                            className="btn btn-sm btn-outline-primary rounded-pill px-3 d-flex align-items-center"
                            onClick={() => openDocumentsModal(user)}
                            title="View Documents"
                          >
                            <FiEye className="me-1" /> Docs
                          </button>
                          <button
                            className="btn btn-sm btn-outline-success rounded-pill px-3 d-flex align-items-center"
                            onClick={() => openModal(user)}
                            title="Add Document"
                          >
                            <BsFileEarmarkText className="me-1" /> Add
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5 text-muted">
                      <div className="empty-state">
                        <i className="bi bi-people display-6 d-block mb-3"></i>
                        <h5>{search ? "No matching customers found" : "No customers available"}</h5>
                        <p className="text-muted">Try adjusting your search or add new customers</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="card-footer bg-light d-flex justify-content-between align-items-center py-3">
          <div className="text-muted">
            Showing <strong>{currentUsers.length}</strong> of <strong>{filteredUsers.length}</strong> entries
          </div>
          <ul className="pagination pagination-sm m-0">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(prev => prev - 1)}>Previous</button>
            </li>
            {[...Array(totalPages)].map((_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(i + 1)}>{i + 1}</button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
            </li>
          </ul>
        </div>
      </div>

      {/* Document Upload Modal */}
      <div className="modal fade" id="userModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow-lg rounded-4">
            <div className="modal-header bg-gradient-success text-white">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <FaRegAddressCard size={20} className="text-white" />
                Add Document for {modalData?.fullName || modalData?.lastName || 'Customer'}
              </h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {modalData && (
                <div className="row">
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Document Type</label>
                      <select
                        className="form-select"
                        value={selectedType}
                        onChange={(e) => setSelectedType(e.target.value)}
                      >
                        <option value="">-- Select Type --</option>
                        <option value="document">Document</option>
                        <option value="source">Source Code</option>
                        <option value="contract">Contract</option>
                        <option value="Project Plan">Project Plan</option>
                        <option value="Project Design">Project Design</option>
                      </select>
                    </div>

                    {selectedType && (
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Upload {selectedType === "document" ? "Document (PDF, ZIP, DOCX)" : 
                                 selectedType === "source" ? "Source Code (ZIP only)" :
                                 selectedType === "contract" ? "Contract (PDF, DOCX)" : "ID Proof (PDF, JPG, PNG)"}
                        </label>
                        <div className="file-upload-area border rounded p-4 text-center">
                          <input
                            type="file"
                            className="form-control visually-hidden"
                            id="documentUpload"
                            accept={selectedType === "document" ? ".pdf,.zip,.docx" : 
                                   selectedType === "source" ? ".zip" :
                                   selectedType === "contract" ? ".pdf,.docx" : ".pdf,.jpg,.png"}
                            onChange={handleDocumentUpload}
                          />
                          <label htmlFor="documentUpload" className="btn btn-outline-primary w-100">
                            <i className="bi bi-cloud-arrow-up me-2"></i>
                            {selectedFile ? selectedFile.name : "Choose File"}
                          </label>
                          <small className="text-muted d-block mt-2">Max file size: 5MB</small>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="preview-section h-100">
                      <h6 className="fw-semibold mb-3">Preview</h6>
                      {selectedFile && (
                        <div className="card border-0 shadow-sm mb-3">
                          <div className="card-body">
                            <div className="d-flex align-items-center mb-2">
                              {getFileIcon(selectedFile.name)}
                              <div>
                                <h6 className="mb-0">{selectedFile.name}</h6>
                                <small className="text-muted">{(selectedFile.size / 1024).toFixed(2)} KB</small>
                              </div>
                            </div>
                            {selectedFile.type === "application/pdf" && (
                              <div className="pdf-preview mt-2">
                                <FaFilePdf className="text-danger display-5" />
                                <p className="text-muted mt-2">PDF Preview</p>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {selectedImage && (
                        <div className="card border-0 shadow-sm">
                          <div className="card-body">
                            <h6 className="fw-semibold mb-3">Image Preview</h6>
                            <img
                              src={URL.createObjectURL(selectedImage)}
                              alt="Preview"
                              className="img-fluid rounded"
                              style={{ maxHeight: "200px" }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-success px-4" onClick={handleSave}>
                <i className="bi bi-save me-2"></i>Save
              </button>
              <button className="btn btn-outline-secondary px-4" data-bs-dismiss="modal">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Documents View Modal */}
      <div className="modal fade" id="documentsModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content border-0 shadow-lg rounded-4">
            <div className="modal-header bg-gradient-primary text-white">
              <h5 className="modal-title d-flex align-items-center gap-2">
                <BsPersonBadge size={20} className="text-white" />
                Documents for {modalData?.fullName || modalData?.lastName || 'Customer'}
              </h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {documents.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Type</th>
                        <th>Document</th>
                        <th>Uploaded</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {documents.map((doc, index) => (
                        <tr key={index}>
                          <td className="text-capitalize">{doc.documentType.replace('_', ' ')}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              {getFileIcon(doc.documentFile)}
                              <span>{doc.documentFile.split('/').pop()}</span>
                            </div>
                          </td>
                          <td>
                            <span className="text-muted">Uploaded on:</span>{" "}
                            <span className="fw-semibold">{new Date(doc.uploadedAt).toLocaleDateString()}</span>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => downloadDocument(doc.documentFile)}
                                title="Download"
                              >
                                <FiDownload />
                              </button>
                              <button 
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => deleteDocument(doc._id)}
                                title="Delete"
                              >
                                <FiTrash2 />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="empty-state text-center py-5">
                  <i className="bi bi-file-earmark-excel display-5 text-muted mb-3"></i>
                  <h5>No documents found</h5>
                  <p className="text-muted">This customer doesn't have any documents yet</p>
                </div>
              )}
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <button 
                className="btn btn-success"
                onClick={() => {
                  const documentsModal = bootstrap.Modal.getInstance(document.getElementById("documentsModal"));
                  documentsModal.hide();
                  openModal(modalData);
                }}
              >
                <BsPlusCircle className="me-2" /> Add Document
              </button>
              <button className="btn btn-primary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .bg-gradient-success {
          background: linear-gradient(135deg, #28a745, #20c997);
        }
        .bg-gradient-primary {
          background: linear-gradient(135deg, #007bff, #17a2b8);
        }
        .text-orange { color: #fd7e14; }
        .hover-shadow:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.05);
          transform: translateY(-2px);
          transition: all 0.3s ease;
        }
        .file-upload-area {
          background-color: #f8f9fa;
          border-radius: 0.5rem;
          cursor: pointer;
        }
        .file-upload-area:hover {
          background-color: #e9ecef;
        }
        .empty-state {
          padding: 2rem;
        }
        .search-box {
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
        }
        .preview-section {
          background-color: #f8fafc;
          padding: 1.5rem;
          border-radius: 0.5rem;
        }
        .pdf-preview {
          text-align: center;
          padding: 1rem;
          background-color: #f8f9fa;
          border-radius: 0.5rem;
        }
      `}</style>
    </div>
  );
}